import React from "react";
import Button from "component/ui/Button";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const PurchasedSlot = ({ bookingListData, setBookingDetails }) => {
  const navigate = useNavigate();

  const handleView = (id) => {
    navigate(`/booking-history/${id}`);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleDownloadInvoice = (orderInvoiceUrl) => {
    const link = document.createElement('a');
    link.href = orderInvoiceUrl;
    link.download = 'invoice.pdf'; // optional: specify the filename you want to use for the download
    link.click();
  };

  return (
    <div className="mx-auto py-5">
      {/* Bookings Grid */}
      <div className="grid grid-cols-1 gap-6">
        {bookingListData?.data?.length > 0 ? (
          bookingListData?.data?.map((booking) => (
            <div
              key={booking.id}
              className="bg-gray-100 p-3 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100 group border border-gray-200"
            >
              {/* Card Header with Gradient */}
              <div className="">
                <div className="flex items-center gap-2">
                  <img
                    src={booking.userProfileImageUrl}
                    alt={booking.userName}
                    className="w-12 h-12 rounded-full border-2 border-white shadow-md object-cover"
                  />
                  <div className="flex-1 min-w-0">
                    <h3 className="text-black font-semibold text-lg truncate">
                      {booking.userName}
                    </h3>
                  </div>
                </div>
              </div>

              {/* Card Body */}
              <div className="md:py-4 py-2 space-y-4">
                {/* Venue */}
                <div className="flex items-start space-x-1">
                  <div className="flex-shrink-0 mt-1">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                      />
                    </svg>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-gray-500 uppercase tracking-wide font-medium">
                      Venue
                    </p>
                    <p className="text-gray-900 font-medium text-sm">
                      {booking.sellerName}
                    </p>
                  </div>
                </div>

                {/* Date */}
                <div className="flex items-start space-x-3">
                  <div className="flex md:flex-row flex-col gap-2 sm:items-center items-start justify-between w-full">
                    <div className="flex items-center gap-2">
                      <div className="flex-shrink-0 mt-1">
                        <svg
                          className="w-5 h-5 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                      </div>

                      <div className="flex-1 min-w-0">
                        <p className="text-xs text-gray-500 uppercase tracking-wide font-medium">
                          Booking Date
                        </p>
                        <p className="text-gray-900 font-medium text-sm">
                          {moment(booking?.createdDateTime).format("DD/MM/YYYY")}
                        </p>
                      </div>
                    </div>

                    <Button onClick={() => handleDownloadInvoice(booking?.orderInvoiceUrl)}>Download Invoice</Button>
                  </div>
                </div>

                {/* Amount */}
                <div className=" border-t border-gray-100">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600 font-medium">
                      Amount Paid
                    </span>
                    <span className="text-xl font-bold text-green-600">
                      ₹{booking.totalAmount}
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center w-full">
                <Button
                  className="w-full"
                  onClick={() => setBookingDetails(booking)}
                >
                  View Details
                </Button>
              </div>
            </div>
          ))
        ) : (
          <div className="h-[40vh] w-full flex justify-center items-center">
            No purchased history available yet
          </div>
        )}
      </div>
    </div>
  );
};

export default PurchasedSlot;
